import React from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import { teamList } from "../../../../components/recoil/teamsRecoil";
import { MultiSelect } from "../../../generic/elements/multiselect/MultiSelect";
import { officeLabel } from "../../../../components/recoil/officeLabelRecoil";

const OfficeSearchAndSelect = ({ teamsOptions }) => {
  const [teams, setTeams] = useRecoilState(teamList);
  const label = useRecoilValue(officeLabel) 

  const handleKeyDown = (e) => {
    e.stopPropagation();
  };

  const handleSelect = (selectedValues) => {
    let finalSelection = selectedValues;

    // If user unselects everything, set all by default
    if (!selectedValues || selectedValues.length === 0) {
      finalSelection = teamsOptions;
    }

    const transformedTeams = finalSelection.map((team) => ({
      ...team,
      name: team.label,
      id: team.value,
    }));

    const isSame =
      transformedTeams.length === teams.length &&
      transformedTeams.every((team, i) => team.id === teams[i]?.id);

    if (!isSame) {
      setTeams(transformedTeams);
    }
  };

  return (
    <>
      <MultiSelect
        options={teamsOptions}
        onKeyDown={handleKeyDown}
        value={teams}
        onChange={handleSelect}
        placeholder={`Click here to select ${label}`}
        isClearable={false}
        allLabel={`All ${label}s`}
        width={280}
      />
    </>
  );
};

export default OfficeSearchAndSelect;
